import React, { ComponentType } from "react";
import useViewportCategory, {
  DESKTOP,
  MOBILE,
  TABLET,
} from "../../../hooks/viewport/useViewportCategory";

type InjectedProps = {
  viewportCategory: typeof DESKTOP | typeof MOBILE | typeof TABLET;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

const withViewportInfoHOC = <P extends Record<string, unknown>>(
  WrappedComponent: ComponentType<P & InjectedProps>
) =>
  function WithViewportInfo(props: P) {
    const viewportCategory = useViewportCategory();

    return (
      <WrappedComponent
        viewportCategory={viewportCategory}
        isMobile={viewportCategory === MOBILE}
        isDesktop={viewportCategory === DESKTOP}
        isTablet={viewportCategory === TABLET}
        {...(props as P)}
      />
    );
  };

export default withViewportInfoHOC;
export type WithViewportInfoHOC<WrappedComponentProps> = Omit<
  WrappedComponentProps,
  keyof InjectedProps
>;
